import { formatDate } from "./format-date"

///* Información de evento
export const fieldEvento = [
  { key: "identificacion", label: "Identificacion" },
  { key: "nombre", label: "Nombre Evento" },
  { key: "capacidad", label: "Capacidad" },
  { key: "direccion", label: "Dirección" },
  {
    key: "fecha_inicio", label: "Fecha Inicio", formatter: (value: unknown) => {
      return formatDate(value as string)
    }
  },
  {
    key: "fecha_fin", label: "Fecha Fin", formatter: (value: unknown) => {
      return formatDate(value as string)
    }
  },
  { key: "nombre_contacto", label: "Nombre Contacto" },
  { key: "numero_contacto", label: "Número Contacto" },
  { key: "tipo_evento", label: "Tipo Evento" },
  { key: "observaciones.observacion_evento", label: "Observación" },
  { key: "coordenadas", label: "Coordenadas" },
  { key: "fecha_creacion", label: "Fecha Creación" },
]

///* Información de canje
export const fieldCanje = [
  { key: "identificacion", label: "Identificacion" },
  { key: "capacidad", label: "Capacidad" },
  { key: "direccion", label: "Dirección" },
  { key: "nombre_contacto", label: "Nombre Contacto" },
  { key: "numero_contacto", label: "Número Contacto" },
  { key: "observaciones.observacion_canje", label: "Observación" },
  { key: "coordenadas", label: "Coordenadas" },
  { key: "fecha_creacion", label: "Fecha Creación" },
]

///* Usuario
export const fieldsUser = [
  { key: "razon_social", label: "Razon social" },
  { key: "email", label: "Email" },
  { key: "area", label: "Area" },
  { key: "cargo", label: "Cargo" },
  { key: "telefono_1", label: "Telefono 1" },
  { key: "telefono_2", label: "Telefono 2" },
  { key: "telefono_3", label: "Telefono 3" },
];


///* Equifax
export const fieldsEquifax = [
  { key: "puntaje_score", label: "Puntaje Score" },
  { key: "puntaje_score_empresa", label: "Puntaje Score Empresa" },
  { key: "puntaje_score_sobreendeudamiento", label: "Puntaje Score Sobreendeudamiento" },
  { key: "segmentacion", label: "Segmentación" }
];


///* referido
export const fieldReferido = [
  { key: "tipo_referido", label: "Tipo" },
  { key: "identificacion_referido", label: "Identificacion" },
  { key: "nombre_referido", label: "Nombre" },
  { key: "contacto_referido", label: "Contacto" },
]

///* plan
export const fieldPlan = [
  { key: "nombre", label: "Nombre" },
  { key: "tipo_plan", label: "Tipo Plan" },
  { key: "tipo_servicio", label: "Tipo Servicio" },
  { key: "valor", label: "Valor" },
  { key: "velocidad_subida_maxima", label: "Velocidad Maxima" },
  { key: "comparticion", label: "Comparticion" },
]

///* observaciones preventa
export const fieldObservacionPreventa = [
  { key: "observacion_1", label: "Observación 1" },
  { key: "observacion_2", label: "Observación 2" },
  { key: "observacion_cancelar", label: "Cancelación" },
]

///* observaciones preventa
export const fieldCanalVenta = [
  { key: "nombre", label: "Canal de Venta" },
  { key: "supervisor", label: "Supervisor" },
]
///* informacion de prospecto

export const fieldProspecto = [
  { key: 'razon_social', label: 'Razon Social' },
  { key: 'identificacion', label: 'Identificación' },
  { key: 'celular', label: 'Celular' },
  { key: 'edad', label: 'Edad' },
  { key: 'puntaje_score', label: 'Puntaje Score' },
  { key: 'puntaje_score_empresa', label: 'Puntaje Score Empresa' },
  { key: 'puntaje_score_sobreendeudamiento', label: 'Puntaje Score Sobreendeudamiento' },
  { key: 'segmentacion', label: 'Segmentación' },
  { key: 'nacionalidad', label: 'Nacionalidad' },
]

///* refencia kardex
export const fieldReferenciaKardex = [
  {key: 'referencia_kardex', label: 'Referencia Kardex', fullWidth: true}
]

///* proveedor
export const fieldProveedor = [
  { key: "identificacion", label: "Identificacion" },
  { key: "nombre_comercial", label: "Nombre Comercial" },
  { key: "direccion", label: "Dirección" },
  { key: "email", label: "Email" },
  { key: "telefono_1", label: "Teléfono 1" },
  { key: "telefono_2", label: "Teléfono 2" },
  { key: "contacto", label: "Contacto" },
  { key: "contacto_cargo", label: "Contacto Cargo" },
  { key: "contacto_telefono_1", label: "Contacto Teléfono 1" },
  { key: "contacto_telefono_2", label: "Contacto Teléfono 2" },
  { key: "contacto_email", label: "Contacto Email" },
  { key: "pais_data.nombre", label: "País" },
  { key: "provincia_data.nombre", label: "Provincia" },
  { key: "ciudad_data.nombre", label: "Ciudad" },
]

///* solicitud beneficio

export const fieldSolicitudBeneficio = [
  { key: "prospecto_data.razon_social", label: "Razón Social" },
  { key: "prospecto_data.identificacion", label: "Identificación" },
  { key: "estado_solicitud", label: "Estado Solicitud" },
  { key: "prospecto_data.es_ayuda_social", label: "Ayuda Social" },
  { key: "prospecto_data.es_bono_humano", label: "Bono De Desarrollo Humano" },
  { key: "prospecto_data.es_curador_tutor", label: "Familiar Con Discapacidad" },
  { key: "prospecto_data.es_discapacitado", label: "Discapacidad" },
  { key: "prospecto_data.es_gremio", label: "Aplica Gremio" },
  { key: "prospecto_data.es_reportado", label: "Score Bajo" },
  { key: "prospecto_data.es_tercera_edad", label: "Tercera Edad" },
  { key: "prospecto_data.reportado", label: "Reportado Por Telco" },
]

export const fieldOsData = [
  { key: "os_data", label: "OS", fullWidth: true },
]


///* Usuario
export const fieldsTraslado = [
  { key: "coordenada", label: "coordenada" },
  { key: "direccion", label: "direccion" },
  { key: "pais", label: "pais" },
  { key: "provincia", label: "provincia" },
  { key: "ciudad", label: "ciudad" },
  { key: "parroquia", label: "parroquia" },
  { key: "sector", label: "sector" },
  { key: "zona", label: "zona" },

];

///* Cuadre
export const fieldsCuadre = [
  { key: "codigo", label: "Código" },
  { key: "bodega_data.nombre", label: "Bodega" },
  { key: "ubicacion_data.nombre", label: "Ubicación" },
  { key: "user_create", label: "Creado por" },
];

///* Egreso
export const fieldsEgreso = [
  { key: "codigo", label: "Código" },
  { key: "bodega_data.nombre", label: "Bodega" },
  { key: "ubicacion_data.nombre", label: "Ubicación" },
  { key: "user", label: "Creado por" },
];
///* orden de compra
export const fieldOrdenCompra = [
  { key: "codigo", label: "Número Referencia"},
  { key: "concepto", label: "Concepto"},
  { key: "estado_orden", label: "Estado Orden"},
  { key: "fecha_compra", label: "Fecha Compra"},
  { key: "fecha_entrega", label: "Fecha Entrega"},
  { key: "forma_pago_data.alias", label: "Forma Pago"},
  { key: "subtotal", label: "Subtotal"},
  { key: "total", label: "Total"},
  { key: "user_create", label: "Usuario Creación"},
]

// series
export const fieldSeries = [
  { key: "series", label: "Series", fullWidth: true },
]
